/**
 * Vintage Editions — Custom Artwork Upload (variant-aware)
 *
 * Toggles between two product variants on art-template products:
 *   - "From our gallery"          → native theme submit, code text input shown
 *   - "Upload your own (+$19.95)" → AJAX multipart submit, file input shown
 *
 * The +$19.95 charge lives on the variant price, so cart/checkout/email/
 * order display need zero custom logic. This script only:
 *   1. Toggles gallery/upload sections on variant change
 *   2. Intercepts submit on the upload variant for multipart POST
 *      (the theme's serialize() strips file inputs)
 *   3. Refreshes quick-cart + header via Shopify Sections API after add
 */
(function () {
  'use strict';

  var CFG = window.VE_CUSTOM_ART || {};
  var MAX_BYTES = (CFG.maxUploadMb || 20) * 1024 * 1024;
  var UPLOAD_MARKER = 'Upload your own';

  function findFormFor(el) {
    var formId = el.getAttribute('data-custom-art-form');
    if (formId) {
      var form = document.getElementById(formId);
      if (form) return form;
    }
    return el.closest('form.product-form') || el.closest('form');
  }

  function variantIsUpload(variant) {
    if (!variant) return false;
    var title = (variant.title || '') + '';
    if (title.indexOf(UPLOAD_MARKER) !== -1) return true;
    var opts = ['option1', 'option2', 'option3'];
    for (var i = 0; i < opts.length; i++) {
      var v = variant[opts[i]];
      if (v && (v + '').indexOf(UPLOAD_MARKER) !== -1) return true;
    }
    return false;
  }

  function readCurrentOptionValues() {
    var values = [];
    var inputs = document.querySelectorAll('[name^="options"]');
    inputs.forEach(function (input) {
      if (input.tagName === 'SELECT') {
        values.push(input.value);
      } else if (input.type === 'radio' && input.checked) {
        values.push(input.value);
      } else if (input.tagName === 'INPUT' && input.type !== 'radio') {
        values.push(input.value);
      }
    });
    return values;
  }

  function isUploadOptionActive() {
    var values = readCurrentOptionValues();
    return values.some(function (v) { return v && (v + '').indexOf(UPLOAD_MARKER) !== -1; });
  }

  function showError(form, msg) {
    var err = document.querySelector('[data-custom-art-error]');
    if (!err) return;
    err.textContent = msg;
    err.removeAttribute('hidden');
  }

  function hideError(form) {
    var err = document.querySelector('[data-custom-art-error]');
    if (err) err.setAttribute('hidden', '');
  }

  function showFilename(wrapper, name) {
    var trigger = wrapper.querySelector('[data-custom-art-trigger]');
    var chip = wrapper.querySelector('[data-custom-art-filename]');
    var label = wrapper.querySelector('[data-custom-art-filename-value]');
    if (label) label.textContent = name;
    if (chip) chip.removeAttribute('hidden');
    if (trigger) trigger.setAttribute('hidden', '');
  }

  function clearFile(wrapper) {
    var fileInput = wrapper.querySelector('[data-custom-art-file]');
    var trigger = wrapper.querySelector('[data-custom-art-trigger]');
    var chip = wrapper.querySelector('[data-custom-art-filename]');
    if (fileInput) fileInput.value = '';
    if (chip) chip.setAttribute('hidden', '');
    if (trigger) trigger.removeAttribute('hidden');
  }

  function applyState(form, wrapper, isUpload) {
    var gallerySection = document.querySelector('[data-custom-art-gallery-section]');
    var uploadSection = document.querySelector('[data-custom-art-upload-section]');
    var codeInput = document.querySelector('[data-custom-art-code]');

    if (isUpload) {
      if (gallerySection) gallerySection.setAttribute('hidden', '');
      if (uploadSection) uploadSection.removeAttribute('hidden');
      if (codeInput) {
        codeInput.removeAttribute('required');
        codeInput.value = '';
        codeInput.dispatchEvent(new Event('input', { bubbles: true }));
        codeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      if (uploadSection) uploadSection.setAttribute('hidden', '');
      if (gallerySection) gallerySection.removeAttribute('hidden');
      clearFile(wrapper);
      hideError(form);
      if (codeInput) codeInput.setAttribute('required', '');
    }
  }

  function validateBeforeAdd(form, wrapper) {
    var codeInput = document.querySelector('[data-custom-art-code]');
    var fileInput = wrapper.querySelector('[data-custom-art-file]');
    hideError(form);

    if (isUploadOptionActive()) {
      var file = fileInput && fileInput.files && fileInput.files[0];
      if (!file) {
        showError(form, 'Please upload your custom photo.');
        return false;
      }
      if (file.size > MAX_BYTES) {
        showError(form, 'File is too large. Max ' + (CFG.maxUploadMb || 20) + ' MB.');
        return false;
      }
      return true;
    }
    var code = codeInput ? codeInput.value.trim() : '';
    if (!code) {
      showError(form, 'Please enter an artwork code (e.g. #LP-107) from our gallery.');
      if (codeInput) {
        try { codeInput.focus(); } catch (_) {}
      }
      return false;
    }
    return true;
  }

  async function submitUpload(form, wrapper, e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var fileInput = wrapper.querySelector('[data-custom-art-file]');
    var file = fileInput && fileInput.files && fileInput.files[0];
    var submitBtn = form.querySelector('button[name="add"], button[type="submit"]');
    var addToCartText = submitBtn ? submitBtn.querySelector('[data-add-to-cart-text]') : null;
    var originalLabel = addToCartText ? addToCartText.textContent : null;
    if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
    if (addToCartText) addToCartText.textContent = 'Uploading...';

    var fd = new FormData(form);
    if (!fd.has('properties[Uploaded File]') && file) {
      fd.set('properties[Uploaded File]', file, file.name);
    }
    fd.delete('properties[Artwork Selection]');

    try {
      var res = await fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' });
      if (!res.ok) {
        var body = await res.json().catch(function () { return {}; });
        showError(form, body.description || body.message || 'Could not add to cart. Please try again.');
        return;
      }
      var item = await res.json();
      await refreshCartUi(item);
      resetFormUi(wrapper);
    } catch (err) {
      showError(form, 'Network error. Please try again.');
    } finally {
      if (submitBtn) submitBtn.removeAttribute('disabled');
      if (addToCartText && originalLabel != null) addToCartText.textContent = originalLabel;
    }
  }

  function refreshCartUi(mainItem) {
    var sectionsToFetch = ['quick-cart', 'header'];
    return fetch('/?sections=' + sectionsToFetch.join(','), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section render HTTP ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        var swappedAny = false;
        sectionsToFetch.forEach(function (name) {
          var html = sections[name];
          if (!html) return;
          var newDoc = new DOMParser().parseFromString(html, 'text/html');
          var newNode = newDoc.querySelector('#shopify-section-' + name);
          var oldNode = document.querySelector('#shopify-section-' + name);
          if (newNode && oldNode) {
            oldNode.replaceWith(newNode);
            document.dispatchEvent(new CustomEvent('shopify:section:load', {
              detail: { sectionId: name, load: true }
            }));
            swappedAny = true;
          }
        });
        if (!swappedAny) throw new Error('no sections swapped');
        return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: mainItem } }));
            document.dispatchEvent(new CustomEvent('quick-cart:open'));
          });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function resetFormUi(wrapper) {
    var fileInput = wrapper.querySelector('[data-custom-art-file]');
    if (fileInput) fileInput.value = '';
    var filenameBlock = wrapper.querySelector('[data-custom-art-filename]');
    var triggerLabel = wrapper.querySelector('[data-custom-art-trigger]');
    if (filenameBlock) filenameBlock.setAttribute('hidden', 'hidden');
    if (triggerLabel) triggerLabel.removeAttribute('hidden');
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-custom-art-upload-wrapper]');
    wrappers.forEach(function (wrapper) {
      var fileInput = wrapper.querySelector('[data-custom-art-file]');
      var form = findFormFor(fileInput || wrapper);
      if (!form) return;

      applyState(form, wrapper, isUploadOptionActive());

      document.addEventListener('product:variant-change', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        var isUpload = variantIsUpload(variant) || isUploadOptionActive();
        applyState(form, wrapper, isUpload);
      });

      var optionInputs = document.querySelectorAll('[name^="options"]');
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          applyState(form, wrapper, isUploadOptionActive());
        });
      });

      if (fileInput) {
        fileInput.addEventListener('change', function () {
          var f = fileInput.files && fileInput.files[0];
          if (f) {
            hideError(form);
            showFilename(wrapper, f.name);
          } else {
            clearFile(wrapper);
          }
        });
      }
      var clearBtn = wrapper.querySelector('[data-custom-art-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          clearFile(wrapper);
          hideError(form);
        });
      }

      form.addEventListener('submit', function (e) {
        if (!validateBeforeAdd(form, wrapper)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        if (isUploadOptionActive()) {
          submitUpload(form, wrapper, e);
        }
      }, true);

      var addBtn = form.querySelector('button[name="add"], button[type="submit"], [data-add-to-cart]');
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          if (!validateBeforeAdd(form, wrapper)) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
